import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

interface ISaveSuccessProps {
    closeModel: Function;
}

const SaveSuccess: React.FC<ISaveSuccessProps> = ({ closeModel }) => {
    const [container, setContainer] = useState<HTMLDivElement | null>(null);

    useEffect(() => {
        const newContainer = document.createElement('div');
        document.body.appendChild(newContainer);
        setContainer(newContainer);

        return () => {
            document.body.removeChild(newContainer);
        };
    }, []);

    const close = () => {
        closeModel();
    };

    return container
        ? (ReactDOM.createPortal(
              <div
                  style={{
                      position: 'absolute',
                      left: '0',
                      top: '0',
                      width: '100%',
                      height: '100%',
                      zIndex: '1000',
                      display: 'flex',
                      background: 'rgba(0,0,0,0.5)',
                      alignItems: 'center',
                      justifyContent: 'center',
                  }}
              >
                  <div
                      style={{
                          position: 'relative',
                          display: 'flex',
                          width: '350px',
                          height: '400px',
                          padding: '30px 20px',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          boxSizing: 'border-box',
                          flexShrink: '0',
                          borderRadius: '25.524px',
                          background: '#FFF',
                          boxShadow: '0px 4.25402px 23.39712px 0px rgba(0, 0, 0, 0.25)',
                      }}
                  >
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="60"
                          height="60"
                          viewBox="0 0 21 22"
                          style={{ marginBottom: '24px' }}
                          fill="none"
                      >
                          <g clipPath="url(#clip0_82_218)">
                              <path
                                  d="M10.5 1.19815C7.87681 1.19815 5.3611 2.24019 3.50626 4.09503C1.65141 5.94988 0.609375 8.46558 0.609375 11.0887C0.609375 13.7119 1.65141 16.2276 3.50626 18.0824C5.3611 19.9373 7.87681 20.9793 10.5 20.9793C13.1231 20.9793 15.6388 19.9373 17.4936 18.0824C19.3485 16.2276 20.3905 13.7119 20.3905 11.0887C20.3905 8.46558 19.3485 5.94988 17.4936 4.09503C15.6388 2.24019 13.1231 1.19815 10.5 1.19815ZM16.3291 8.19494L9.52063 15.0047L9.50894 15.0138L9.50765 15.0164C9.49985 15.0242 9.48946 15.0294 9.48167 15.0359C9.45525 15.0608 9.42704 15.0839 9.39725 15.1047L9.35958 15.1255C9.33101 15.1424 9.30243 15.1593 9.27126 15.1722L9.2245 15.1878C9.19463 15.1969 9.16475 15.2086 9.13358 15.2151C9.01071 15.2404 8.88344 15.2346 8.76341 15.198C8.64339 15.1615 8.53443 15.0955 8.4465 15.006L4.67211 11.229C4.54482 11.0847 4.47732 10.8974 4.48339 10.7051C4.48945 10.5127 4.56861 10.33 4.70474 10.194C4.84087 10.0581 5.02372 9.97913 5.21603 9.9733C5.40834 9.96747 5.59563 10.0352 5.73975 10.1627L8.98422 13.4084L15.2641 7.1286C15.4085 7.00333 15.5951 6.93745 15.7861 6.94423C15.9772 6.95102 16.1586 7.02996 16.2938 7.16516C16.429 7.30036 16.508 7.48177 16.5148 7.67285C16.5215 7.86394 16.4557 8.05049 16.3304 8.19494H16.3291Z"
                                  fill="#5F88FF"
                              />
                          </g>
                          <defs>
                              <clipPath id="clip0_82_218">
                                  <rect
                                      width="20.7812"
                                      height="20.7812"
                                      fill="white"
                                      transform="translate(0.109375 0.698242)"
                                  />
                              </clipPath>
                          </defs>
                      </svg>
                      <div
                          style={{
                              color: '#000',
                              textAlign: 'center',
                              fontFamily: 'Inter',
                              fontSize: '20px',
                              fontStyle: 'normal',
                              fontWeight: '600',
                              lineHeight: 'normal',
                              marginBottom: '16px',
                          }}
                      >
                          保存成功
                      </div>

                      <div
                          style={{
                              color: '#000',
                              textAlign: 'center',
                              fontFamily: 'Inter',
                              fontSize: '18px',
                              fontStyle: 'normal',
                              fontWeight: '400',
                              lineHeight: '24px',
                              marginBottom: '16px',
                          }}
                      >
                          您的稿件已经保存至系统，请返回mcp平台等待审核
                      </div>

                      <div
                          style={{
                              display: 'inline-flex',
                              padding: '10px 60px 10px 60px',
                              justifyContent: 'center',
                              alignItems: 'center',
                              borderRadius: '22px',
                              background: '#5F88FF',
                              color: '#F1F1F1',
                              textAlign: 'center',
                              fontFamily: 'Inter',
                              fontSize: '18px',
                              fontStyle: 'normal',
                              fontWeight: '600',
                              lineHeight: 'normal',
                              cursor: 'pointer',
                          }}
                          onClick={close}
                      >
                          我知道了
                      </div>
                  </div>
              </div>,
              container,
          ) as any)
        : null;
};

export default SaveSuccess;
